import React from "react";

const ITEMS = [
  "Guincho 24 Horas",
  "Reboque",
  "Socorro Veicular",
  "Transporte",
  "Remoção",
  "Porto Alegre",
];

export const Marquee = () => {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="brand-marquee"
      className="relative bg-[#050505] border-y border-white/10 py-6 md:py-8 overflow-hidden"
    >
      <div className="flex whitespace-nowrap animate-marquee">
        {row.map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-bold uppercase text-4xl md:text-6xl text-stroke px-8">
              {item}
            </span>
            <span className="text-[#e60000] text-3xl md:text-5xl">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};
